import { Component, Inject, Input, Optional } from '@angular/core';
import { CONFIG_MODAL_INPUTS_TOKEN, ModalOverlayRef } from '@core/classes/modal-overlay.ref';

@Component({
  selector: 'mfp-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss']
})
export class DialogComponent {
  @Input() size: 'content' | 'fixed' = 'content';
  @Input() type: 'success' | 'warning' = 'success';
  @Input() title = '';
  @Input() text = '';
  @Input() successAction = '';
  @Input() cancelAction = '';

  private successCallback: (() => void) | undefined;
  private cancelCallback: (() => void) | undefined;

  constructor(public dialogRef: ModalOverlayRef, @Optional() @Inject(CONFIG_MODAL_INPUTS_TOKEN) config: any) {
    if (config) {
      this.size = config.size;
      this.type = config.type;
      this.title = config.title;
      this.text = config.text;
      this.successAction = config.successAction;
      this.cancelAction = config.cancelAction;
      this.successCallback = config.successCallback;
      this.cancelCallback = config.cancelCallback;
    }
  }

  closeOnCancel() {
    this.dialogRef.close();
    this.cancelCallback?.();
  }

  closeOnSuccess() {
    this.dialogRef.close();
    this.successCallback?.();
  }
}
